module.exports = __webpack_public_path__ + "static/img/bg-02.ee93c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/bg-02.jpg
// module id = qX5F
// module chunks = 1